<script lang="ts">
    import { kirbyFetch } from "../../../../api/kirby/api"
    import { lang, location } from "../../../../store"
    import NavigationCardItem from "./NavigationCardItem.svelte"
    let {
        noPadding,
        items,
    }: {
        noPadding?: boolean
        items: SubnavigationItem[]
        animate?: boolean
    } = $props()
    let loading = $state(true)
    let ulEl: HTMLElement | null = $state(null)
    let hideFirstItem = $state(false)

    let renderedItems = $state(items)

    type NavigationPage = {
        uuid: string
        url: string
    }

    async function loadRenderedItems(currentLang: string) {
        if (!items?.[0]?.link.includes("page://")) {
            renderedItems = items
            loading = false
            return
        }

        loading = true
        const pages =
            (await kirbyFetch<NavigationPage[]>({
                query: `site.index.filterBy('Uuid', 'in', ['${items.map((el) => el.link).join("','")}'])`,
                select: {
                    uuid: true,
                    url: true,
                },
            })) || []
        renderedItems = items.map((item) => {
            const pageUrl = pages.find((page) => page.uuid === item.link)?.url
            if (!pageUrl) return item
            return {
                ...item,
                link: `/${currentLang}/` + pageUrl.split(`/${currentLang}/`).pop(),
            }
        })
        loading = false
    }

    // Top-Level: nur SSR (goja löst Promises synchron)
    if (typeof window === "undefined") loadRenderedItems(String($lang || ""))

    // $effect: Client + SPA-Sprachwechsel
    $effect(() => {
        const currentLang = String($lang || "")
        if (!currentLang) return
        void loadRenderedItems(currentLang)
    })

    function hasBestPathMatch(item: SubnavigationItem): boolean {
        if (!$location.path.includes(item.link)) return false
        const itemPath = item.link.split("/").filter(Boolean)
        const currentPath = $location.path.split("/").filter(Boolean)
        return (
            itemPath.length === currentPath.length && itemPath.every((segment, index) => segment === currentPath[index])
        )
    }
</script>

<div class="navigation-nav-card {noPadding ? 'noPadding' : ''}">
    <ul bind:this={ulEl}>
        {#if !loading}
            {#each renderedItems?.filter((_, idx) => !(idx === 0 && hideFirstItem)) as item, idx}
                <li>
                    <NavigationCardItem
                        activated={$location.path.includes(item.link)}
                        colored={hasBestPathMatch(item)}
                        text={item.text}
                        path={item.link}
                    />
                </li>
            {/each}
        {/if}
    </ul>
</div>

<style lang="less">
    .navigation-nav-card {
        position: relative;
        display: flex;
        gap: 2.4rem;
        height: 480px;
        width: 100%;
        padding: 2.4rem;
        ul {
            width: 100%;
            flex-grow: 1;
            display: grid;
            grid-template-rows: repeat(4, auto);
            grid-auto-columns: 1fr;
            max-height: 260px;
            grid-auto-flow: column;
            gap: 0.9rem;
            li {
                padding-bottom: 0.9rem;
                width: 100%;
                height: fit-content;
                border-bottom: 1px solid var(--dark-20);
            }
        }
        &.noPadding {
            padding: 0px !important;
            ul {
                display: flex;
                flex-direction: column;
            }
        }
        @media (max-width: 1200px) {
            height: initial;
            flex-direction: column;
            gap: 0.2rem;
            padding: 0px;
            ul {
                gap: 0.2rem;
                width: 100%;
                display: flex;
                flex-direction: column;
                li {
                    padding-bottom: 0.2rem;
                }
            }
            ul:last-of-type {
                li:last-of-type {
                    border-bottom: none;
                }
            }
        }
    }
</style>
